"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var overlay_1 = require("./overlay");
exports.NguiOverlay = overlay_1.NguiOverlay;
var overlay_manager_1 = require("./overlay-manager");
exports.NguiOverlayManager = overlay_manager_1.NguiOverlayManager;
var overlay_directive_1 = require("./overlay.directive");
exports.NguiOverlayDirective = overlay_directive_1.NguiOverlayDirective;
var overlay_module_1 = require("./overlay.module");
exports.NguiOverlayModule = overlay_module_1.NguiOverlayModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/overlay/dist/index.js
// module id = 83
// module chunks = 4